export const ACTIONS = {
  GET_INFORMATION: 'SERVICE_COMPANY__GET_INFORMATION',
  UPDATE_INFORMATION: 'SERVICE_COMPANY__UPDATE_INFORMATION',
};
